<template>
  <div id="chinaUserConsentPopup" class="modal fade china-modal confirmation-popup" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header generic-header">
          Terms and Conditions
          <!-- <img
              class="close-icon cursor-pointer"
              data-dismiss="modal"
              data-target="#chinaUserConsentPopup"
              src="/static/images/icons/close_icon.svg"
            /> -->
        </div>
        <div class="modal-body pt-0">
          <!-- <div class="modal-note mb-15">
            Please update your email preference below. Email communication helps us keep you
            informed.
          </div> -->
          <template>
            <div class="activityTracker-checkbox mb-15">
              <span class="checkbox">
                <label>
                  <input type="checkbox" name="terms-private" v-model="dataConsent" />
                  <span class="cr">
                    <img class="select-check" src="/static/images/icons/select_check.svg" alt="" />
                  </span>
                </label>
              </span>
              <div for="terms" class="terms-conditions ml-15">
                By clicking this checkbox, I agree Emergo by UL Solutions may process my personal
                information in accordance with the
                <a
                  class="term-priv"
                  href="https://www.ul.com/resources/online-policies"
                  target="_blank"
                  >Emergo by UL Solutions’ Online Policies
                </a>
                and to the cross-border transfer of my personal information to the United States.
              </div>
            </div>
          </template>
        </div>
        <div class="modal-footer text-center">
          <button
            type="button"
            class="btn emergo-blue-button"
            @click="updateConsent()"
            :disabled="disableSubmit"
          >
            Submit
          </button>
        </div>
      </div>
      <loader :loadingStatus="loaderStatus" />
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
// import postMarketoFormData from '../../apis/marketo';
import { updateConsent } from '../../apis/userConsent';
import Loader from '../UIComponents/Loader.vue';
import BaseTooltip from '../Common/BaseTooltip.vue';

export default {
  components: { Loader, BaseTooltip },
  props: ['consentType'],
  data() {
    return {
      emailOptin: false,
      dataConsent: false,
      loaderStatus: false
    };
  },
  computed: {
    disableSubmit() {
      return !this.dataConsent;
    }
  },
  methods: {
    async updateConsent() {
      this.loaderStatus = true;
      const res = await updateConsent({ consent_type_id: this.consentType.id });
      this.loaderStatus = false;
      if (res && res.status_code === 200 && res.message === 'success') {
        this.clearNotifications();
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Terms and conditions accepted.',
          group: 'custom-notification'
        });
        $('#chinaUserConsentPopup').modal('hide');
      } else {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'We had a problem updating your consent. Please try again.',
          group: 'custom-notification'
        });
      }
    },
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.china-modal {
  background: rgba(0, 0, 0, 0.8);
}
.modal-content {
  border-radius: 10px;
}
.modal-header {
  padding: 25px 25px 10px;
  background: #fff;
  border-radius: 10px;
  border: 0;
  font-family: $font-family-roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 28px;
  color: $primary;
}
.modal-footer {
  background: #fff;
  border-radius: 10px;
  border: 0;
  padding: 20px 35px;
  text-align: center;
  .btn {
    margin: 0;
    &:not(:last-child) {
      margin-right: 24px;
    }
  }
  .emergo-blue-button {
    padding: 6px 68px !important;
  }
}
.close-icon {
  position: absolute;
  top: 18px;
  right: 18px;
}
.modal-dialog {
  .form-control.text-box {
    height: 150px;
    resize: none;
  }
}
.info-icon {
  width: 58px;
  height: 58px;
}
.modal-body {
  font-family: $font-family-roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: $dark-black-alpha;
  margin: 0 35px;
  padding: 15px 0;
  .sub-header {
    color: $dark-black-alpha;
    font-family: $font-family-roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 28px;
    padding-top: 25px;
    padding-bottom: 20px;
  }
  .modal-note {
    font-family: $font-family-roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: $dark-black-alpha;
  }
  .terms-conditions ml-15 {
    font-family: $font-family-roboto;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: $dark-black-alpha;
    // margin-left: 16px;
    margin-top: 3px;
    .term-priv {
      color: #2f80ed;
      font-size: 14px;
      font-weight: 600;
    }
    &.ml-0 {
      margin-left: 0;
    }
  }
  .activityTracker-checkbox {
    display: flex;
    img.select-check {
      width: 11px;
    }
    > .checkbox {
      margin-top: 3px;
    }
  }
}
.confirmation-popup {
  .modal-dialog {
    width: 500px;
  }
}
.hide-btn {
  visibility: hidden;
}
@media screen and (max-width: 767px) {
  .confirmation-popup {
    .modal-dialog {
      width: 90%;
    }
    .modal-body {
      margin: 0 25px;
    }
  }
  .xs-mb-10 {
    margin-bottom: 10px;
  }
  .modal-footer {
    div {
      flex-direction: column;
      .btn {
        &:not(:last-child) {
          margin-bottom: 10px;
        }
      }
    }
  }
  .hide-btn {
    display: none;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .confirmation-popup {
    .modal-dialog {
      width: 90%;
    }
    .modal-body {
      margin: 0 35px;
    }
  }
}
</style>
